import { createContext } from 'react';
import { UseRouter } from './types';

const stub = (): never => {
  throw new Error('Component must have an upstream <RouteProvider> parent');
};

export interface RouteControllerContext extends Omit<UseRouter, 'prevRoute' | 'prevState'> {
  prevPathname: string;
}

const initialContext: RouteControllerContext = {
  currentHashValue: window.location.hash.slice(1),
  currentURL: new URL(window.location.href),
  prevPathname: '',
  searchOptions: {},
  navigate: stub,
  setSearchOptions: stub,
};

export const RouteContext = createContext<UseRouter>(initialContext);
